// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-joyride__tooltip button{color:#2715ff}.react-joyride__tooltip button:focus{outline:none}`, "",{"version":3,"sources":["webpack://./src/components/sbbTours/tours.scss"],"names":[],"mappings":"AACE,+BACE,aAAA,CACA,qCAAA,YAAA","sourcesContent":[".react-joyride__tooltip button{color:#2715ff}.react-joyride__tooltip button:focus{outline:none}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
